/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);

const $cleanSearch  = $el.find('.clean-search');
const $formSearch   = $el.find('form');
const $inputSearch  = $el.find('[name="q"]');
const $toggleSearch = $('.toggle-search');

// $el.addEventListener('submit', function() {
//     const $input = $el.find('[name="q"]');
//     const value  = stripTags($input.val());


//     $input.val(value);
// });

$formSearch.on('submit', function(e) {
    const value = $inputSearch.val();

    if(value.length < 3) {
        e.preventDefault();
    };
});

$cleanSearch.on('click', function(e) {
    e.preventDefault();

    $cleanSearch.removeClass('is-active');
    $inputSearch.val('').focus();

    if (Is.mobile.ANY()) {
        $el.removeClass('is-active');
        $toggleSearch.removeClass('is-active');
    }
});

$inputSearch.on('keyup blur', function() {
    const value = $inputSearch.val();

    if( value != '' ) {
        $cleanSearch.addClass('is-active');
    } else  {
        $cleanSearch.removeClass('is-active');
    }
}).trigger('keyup');
